/**
 * Customized Theming
 */ 
import { Theme } from 'svelte-stylo'

let theme = Theme.get('default');

theme.icons = {

  source: 'assets/svg',
  prefix: 'mdi-',
  files: {
    // Panel buttons
    'expand': 'chevron-down',
    'collapse': 'chevron-up',
    'close': 'close',

    // Field status
    'empty': 'asterisk',
    'valid': 'check-bold',
    'error': 'alert-decagram',

    // Field toggles
    'show': 'eye',
    'hide': 'eye-off',
    
    // Field buttons
    'check-on': 'checkbox-marked-circle-outline',
    'check-off': 'checkbox-blank-circle-outline',
    'add': 'plus',
    'delete': 'delete',

    // Field actions
    'open-editor': 'file-edit',
    'scan-qrcode': 'barcode',
    'add-attachment': 'attachment',
    'capture-camera': 'camera',
    'add-from-gallery': 'image',
    'open-calendar': 'calendar',
    'query': 'database-search',
    'upload': 'upload',
    'download-report': 'file-download',
    //
    'timer': '',
    'gps': '',
    'chart': '',
    'item': '',

    // Document types
    'xls': 'microsoft-excel',

    // states
    'warning': 'alert-outline',
    'info': 'information-outline',
  }
}

theme.colors['primary++'] = '#ab3a3a';

theme.colors['info++'] = "hsl(211deg 99% 62%)";

theme.colors['dark--'] = '#515155',

theme.colors['light'] = '#ededef';
theme.colors['light-'] = 'hsl(58deg 10% 96%)';
theme.colors['light+'] = '#dadade';
theme.colors['light++'] = '#cecece';

theme.colors['input'] = 'orange';
theme.colors['green-'] = 'hsl(120 33% 64% / 1)';

theme.borders['input'] = '1px solid orange';
theme.borders['disabled'] = '1px solid #ddd';
theme.borders['debug'] = '1px dotted blue';

theme.borders['plus'] = '2px dashed hsl(120 33% 76% / 1)';

theme.shadows['fab'] = '0 4px 6px -1px rgba(0, 0, 0, 0.7), 0 2px 4px -1px rgba(0, 0, 0, 0.06)';

theme.variants = {};

theme.variants['field-icon-button'] = {
  color:"dark",
  border:"5",
  pointer: true, 
  hover: true, 
  round: true,
  size:"xl", 
  w: "2.5", 
  h:"2.5",
  ml: "xs",
  mb: "2px"
}

theme.variants['states'] = {
  'A': { color:"white", bg: 'success' },
  'E': { color:"white", bg: 'orange' },
  'I': { color:"white", bg: 'gray700' }
}


export function customizedTheme() {
  Theme
    .wireframes(false)
    .build('default', theme)
    .active('default');
}
